<template>
    <div class="menu-list">
        <div class="list-group"
             v-for="(section, section_name) in menu"
             :key="section_name"
             v-if="! Array.isArray(section)"
        >
            <a :href="'#'+section_name" class="list-group-item" data-toggle="collapse" aria-expanded="true">{{ section_name }}</a>
            <div class="collapse show" :id="section_name">
                <a :class="['list-group-item', (current_url + '/').includes(key + '/') ? 'current': '']"
                   v-for="(item, key) in section"
                   :key="key"
                   :href="key"
                >
                    {{ item }}
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                locale: window.locale,
            }
        },
        props: {
            menu: {
                type: Object,
                required: true,
            },
            current_url: {
                type: String,
                required: true,
            }
        },
        methods: {},
        watch: {
            filter() {
                this.fetchData(this.url + this.$store.getters.query + '&page=' + this.page);
            },
            url() {
                if (this.url != '')
                    this.fetchData(this.url + this.$store.getters.query + '&page=' + this.page);
            }
        },
        computed: {
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Modules/Menu.vue